import moment from "moment";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const columns = () => {
  return [
    {
      title: '安排名称',
      name: 'planName',
      dataIndex: 'planName',
      searchItem: {},
    },
    {
      title: '计划名称',
      name: 'name',
      dataIndex: 'name',
      tableItem: {
        width: 150
      }
    },
    {
      title: "计划安排时间",
      dataIndex: "applyPlanTime",
      name: "applyPlanTime",
      tableItem: {
        width: 250,
        render: (text, record) => {
          const {startTime, endTime} = record;
          return formatterDate(startTime) + " ~" + formatterDate(endTime)
        }
      }
    },
    {
      title: "地点",
      dataIndex: "address",
      name: "address",
      tableItem:{
        width: 200
      }
    },
    {
      title: "限制人数",
      dataIndex: "limitCount",
      name: "limitCount",
      tableItem:{
        width: 100
      }
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'applyPlan/queryAdjustPlanList',
    ...api
  }
};

const adjustPlan = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'planId',
    columns: columns(),
    tableApi: tableApi(api)
  }
};

export default adjustPlan
